import { render, staticRenderFns } from "./Indienen.vue?vue&type=template&id=dafaf2dc&scoped=true&"
import script from "./Indienen.vue?vue&type=script&lang=js&"
export * from "./Indienen.vue?vue&type=script&lang=js&"
import style0 from "./Indienen.vue?vue&type=style&index=0&id=dafaf2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafaf2dc",
  null
  
)

export default component.exports